/**
 * ч.1397 — одноразове перенесення сесії зі старого localStorage у httpOnly-cookie.
 *
 * Користувач, який увійшов до ч.1397, має у localStorage refresh-токен і жодної cookie.
 * Замість вимагати повторний вхід — обмінюємо старий refresh на cookie-сесію одним запитом
 * (сервер приймає токен у тілі й ставить cookie, бо є `X-Session: cookie`), а старі ключі
 * стираємо в будь-якому разі. Викликається ДО першого рендера (`main.tsx`).
 */
import { LEGACY_TOKEN_KEYS, setSession } from './store';

export async function migrateLegacySession(): Promise<void> {
  let legacy: string | null = null;
  try { legacy = localStorage.getItem('auth.refresh'); } catch { return; }
  if (!legacy) return;
  try {
    const r = await fetch('/api/v1/auth/refresh', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'X-Session': 'cookie' },
      body: JSON.stringify({ refresh_token: legacy }),
    });
    if (r.ok) {
      const data = (await r.json().catch(() => ({}))) as { user_id?: string | null };
      setSession(data.user_id ?? null);
    }
  } catch { /* старий токен недійсний або мережі немає — користувач увійде заново */ }
  finally {
    for (const k of LEGACY_TOKEN_KEYS) { try { localStorage.removeItem(k); } catch { /* ok */ } }
  }
}
